import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-838e1d6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["x1", "y1", "x2", "y2"]

import { Vector2 } from "@/utils/block";


// [head, tail]

export default /*#__PURE__*/_defineComponent({
  props: {
    positions: null
  },
  setup(__props: any) {

const props = __props as {
  positions: [Readonly<Vector2>, Readonly<Vector2>];
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("line", {
    x1: props.positions[0][0],
    y1: props.positions[0][1] - 15,
    x2: props.positions[1][0] + 7,
    y2: props.positions[1][1] - 15,
    stroke: "gray",
    "stroke-width": "2",
    "stroke-dasharray": "4"
  }, null, 8, _hoisted_1))
}
}

})